import { useEffect } from "react";
import { useAppDispatch, actions } from "store";
export var KeyBindings;
(function (KeyBindings) {
    KeyBindings["DELETE"] = "Delete";
    KeyBindings["ESCAPE"] = "Escape";
})(KeyBindings || (KeyBindings = {}));
export var useKeyBindings = function (_a) {
    var keys = _a.keys, disabled = _a.disabled, node = _a.node, edge = _a.edge;
    var dispatch = useAppDispatch();
    useEffect(function () {
        if (disabled || (!node && !edge))
            return;
        var handleDelAndEscKeys = function (event) {
            var shouldDelete = keys.includes(KeyBindings.DELETE) && event.key === "Delete";
            var shouldDeselect = keys.includes(KeyBindings.ESCAPE) && event.key === "Escape";
            if (shouldDelete && node) {
                dispatch(actions.deleteNode(node.id));
            }
            else if (shouldDelete && edge) {
                dispatch(actions.deleteEdge(edge.id));
            }
            else if (shouldDeselect) {
                dispatch(actions.deselectEntities());
            }
        };
        window.addEventListener("keydown", handleDelAndEscKeys);
        return function () {
            window.removeEventListener("keydown", handleDelAndEscKeys);
        };
    }, [disabled, dispatch, edge, keys, node]);
};
